import React, { useState, useEffect } from "react";
import PropTypes from "kf-proptypes/widgets";
import dayjs from "dayjs";

import { DatePanel } from "./datepanel.jsx";

import styles from "./daterangepanel.css";

const DATE_COMPARISON_FORMAT = "DD/MM/YYYY";

/**
 * The Date Range Panel Component is used user to pick time period from date to to date
 */

export function DateRangePanel(props) {
  const {
    startDate,
    endDate,
    onChange,
    onSelectStartDate,
    startsAt,
    endsAt,
    className
  } = props;
  const [rangeStartDate, setRangeStartDate] = useState(null);
  const [rangeEndDate, setRangeEndDate] = useState(null);
  const [firstPanelValue, setFirstPanelValue] = useState();
  const [secondPanelValue, setSecondPanelValue] = useState();
  const [hoveredDate, setHoveredDate] = useState();

  useEffect(
    function initEffect() {
      setRangeStartDate(startDate);
      setRangeEndDate(endDate);
    },
    [startDate, endDate]
  );

  useEffect(function panelEffect() {
    setFirstPanelValue(startDate || dayjs());
    setSecondPanelValue(
      (startDate && startDate.clone().add(1, "month")) ||
        dayjs().add(1, "month")
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleOnSelect = (date) => {
    if (!rangeStartDate && !rangeEndDate) {
      setRangeStartDate(date);
    } else if (date.diff(rangeStartDate, "days") === 0) {
      if (rangeEndDate) {
        setRangeStartDate(rangeEndDate);
        setRangeEndDate(null);
      } else {
        setRangeStartDate(null);
      }
    } else if (date.diff(rangeEndDate, "days") === 0) {
      setRangeEndDate(null);
    } else if (rangeStartDate && !rangeEndDate) {
      if (date.diff(rangeStartDate, "days") < 0) {
        setRangeEndDate(rangeStartDate);
        setRangeStartDate(date);
      } else {
        setRangeEndDate(date);
      }
    } else if (rangeStartDate && rangeEndDate) {
      setRangeStartDate(date);
      setRangeEndDate(null);
    }
  };

  useEffect(
    function rangeStartEffect() {
      if (rangeStartDate && rangeEndDate) {
        onChange && onChange({ start: rangeStartDate, end: rangeEndDate });
      } else {
        if (rangeStartDate) {
          onSelectStartDate && onSelectStartDate(rangeStartDate);
        }
        onChange && onChange(null);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [rangeStartDate, rangeEndDate]
  );

  const dateRenderer = (date) => {
    let hoverClassName = "";
    if (
      !(rangeEndDate && rangeStartDate) &&
      (rangeEndDate || rangeStartDate) &&
      date.isBetween &&
      date.isBetween(rangeStartDate || rangeEndDate, hoveredDate)
    ) {
      hoverClassName = styles.hoverDate;
    }
    return (
      <div
        onMouseEnter={() => {
          setHoveredDate(date);
        }}
        onMouseLeave={() => {
          setHoveredDate(null);
        }}
        className={`ant-picker-cell-inner ${
          // eslint-disable-next-line no-nested-ternary
          (rangeStartDate &&
            date.format(DATE_COMPARISON_FORMAT) ===
              rangeStartDate.format(DATE_COMPARISON_FORMAT)) ||
          (rangeEndDate &&
            date.format(DATE_COMPARISON_FORMAT) ===
              rangeEndDate.format(DATE_COMPARISON_FORMAT))
            ? styles.selected
            : date.isBetween && date.isBetween(rangeStartDate, rangeEndDate)
            ? styles.inrange
            : ""
        } ${hoverClassName}`}
      >
        {date.format("D")}
      </div>
    );
  };

  return (
    <div className={`${styles.daterangepanel} ${className}`}>
      <DatePanel
        onChange={handleOnSelect}
        dateRender={dateRenderer}
        pickerValue={firstPanelValue}
        className={styles.leftdatepanel}
        onPanelChange={(date, mode) => {
          const nextMonth = date.clone().add(1, "month");
          setSecondPanelValue(nextMonth);
          setFirstPanelValue(date);
        }}
        startsAt={startsAt}
        endsAt={endsAt}
      />
      <DatePanel
        onChange={handleOnSelect}
        dateRender={dateRenderer}
        pickerValue={secondPanelValue}
        className={styles.rightdatepanel}
        onPanelChange={(date, mode) => {
          const previousMonth = date.clone().add(-1, "month");
          setFirstPanelValue(previousMonth);
          setSecondPanelValue(date);
        }}
        startsAt={startsAt}
        endsAt={endsAt}
      />
    </div>
  );
}

DateRangePanel.propTypes = {
  /**
   * Selected StartDate
   */
  startDate: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.bool,
    PropTypes.object
  ]),
  /**
   * Selected EndDate
   */
  endDate: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.bool,
    PropTypes.object
  ]),
  /**
   * If user choose the range then this onchange prop will trigger
   */
  onChange: PropTypes.func,
  /**
   * If user select a start value in calendar this onSelectStartDate prop will trigger
   */
  onSelectStartDate: PropTypes.func,
  /**
   * User cannot select date before starts at
   */
  startsAt: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.bool,
    PropTypes.object
  ]),
  /**
   * User cannot select date past ends at
   */
  endsAt: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.bool,
    PropTypes.object
  ]),
  /**
   * To override default styles of range panel
   */
  className: PropTypes.string
};
